var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/_html.js
// module id = 64
// module chunks = 0 1 2 3 4